const refundContent = {
  title: 'Te devolvemos tu dinero',
  message: 'Realizaste un pago de:',
  paidAmount: '[paid]',
  customer: 'Nuestro equipo de customer care realizará tu devolución. Si pagaste con tarjeta de crédito o debito en 5 días habiles, si pagaste en efectivo de 15 a 20 días. No te preocupes, en breve te contactamos.',
  currency: ' [currency]'
}

export default refundContent
